import { Cart, ItemBody } from '@adapters/bigcommerce/types/cart';
import findifyAnalyticsUpdateCart from '@adapters/findify/operations/analytics/updateCart';
import klaviyoAddToCart from '@adapters/klaviyo/operations/analytics/addToCart';
import { RRTrackAddToCart } from '@components/global/Recommendations/Loader';
import { trackCartViewEvent } from '@utils/gtm/ga4';
import { GA4_EVENT_NAMES } from '@utils/gtm/ga4';

const { MINI_CART, VIEW_CART } = GA4_EVENT_NAMES;

export const triggerAnalytics = ({
  data,
  items = [],
  categories,
  categoryId,
  trackMiniCartView = true,
}: {
  data: Cart;
  items?: ItemBody[];
  categories?: string[];
  categoryId?: string;
  /** Push GA4 `view_cart` (`cart_type: 'mini cart'`). Only callers that open
      the cart flyout after adding should leave this on — quick add never
      shows the mini cart, so it passes `false`. */
  trackMiniCartView?: boolean;
}) => {
  if (trackMiniCartView) {
    trackCartViewEvent({
      eventName: VIEW_CART,
      cart: data,
      extraAttributes: { cart_type: MINI_CART },
    });
  }
  findifyAnalyticsUpdateCart({ data });
  items.forEach((item) => klaviyoAddToCart({ data, item, categories }));
  RRTrackAddToCart({
    items: items
      .filter((item) => item.productId && item.variantId)
      .map((item) => {
        const selectedItem = data?.cartData?.line_items.physical_items.find(
          (x) =>
            x.product_id === item.productId && x.variant_id === item.variantId
        );
        return {
          itemId: selectedItem?.code ?? '',
          skuId: selectedItem?.sku.toString() ?? '',
        };
      }),
    categoryId,
  });
};
